export const requestProductImageUrl = "/images/RequestProduct.png";
export const successlogo = "/images/Green_Tick.png";
export const startLogo = "/images/ph_logo.png";
export const fabpiks = "/images/Fabpiks.png";
